// src/components/ui/Alert.js
import React from 'react';
import { AlertTriangle, Info, CheckCircle2, XCircle } from 'lucide-react';

const variants = {
  info: {
    container: 'bg-blue-50 border-blue-100 text-blue-800',
    icon: Info,
    iconColor: 'text-blue-600',
  },
  warning: {
    container: 'bg-amber-50 border-amber-100 text-amber-800',
    icon: AlertTriangle,
    iconColor: 'text-amber-600',
  },
  success: {
    container: 'bg-green-50 border-green-100 text-green-800',
    icon: CheckCircle2,
    iconColor: 'text-green-600',
  },
  destructive: {
    container: 'bg-red-50 border-red-100 text-red-800',
    icon: XCircle,
    iconColor: 'text-red-600',
  },
  brand: {
    container: 'bg-indigo-50 border-indigo-100 text-indigo-800',
    icon: Info,
    iconColor: 'text-indigo-600',
  }
};

export function Alert({ 
  children, 
  title, 
  variant = 'info', 
  className = '',
  icon: CustomIcon
}) {
  const config = variants[variant] || variants.info;
  const Icon = CustomIcon || config.icon;

  return (
    <div className={`flex items-start p-4 border rounded-xl ${config.container} ${className}`}>
      <Icon className={`w-5 h-5 mr-3 mt-0.5 flex-shrink-0 ${config.iconColor}`} />
      <div className="flex-grow">
        {title && <h3 className="text-sm font-bold mb-1">{title}</h3>}
        <div className="text-sm">
          {children}
        </div>
      </div>
    </div>
  );
}
